import { render, staticRenderFns } from "./login-singpass-callback.vue?vue&type=template&id=79135762&"
import script from "./login-singpass-callback.vue?vue&type=script&lang=js&"
export * from "./login-singpass-callback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports